module.exports = __webpack_public_path__ + "img/Fei_Wu@2x.4ce488b3.png";